<div fxLayout="column">
  <div fxLayout="row" fxLayoutAlign="space-between center" class="mb-4" mat-dialog-title>
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
      <img src="assets/img/chatbot-ai.png" style="width:28px;height:28px;border-radius:50%;" alt="KumoAgent" />
      <div>
        <div style="font-size:16px;font-weight:700;line-height:1.2">Global KumoAgent</div>
        <div style="font-size:12px;color:var(--text-secondary)">Ask anything — blueprints, instances, devices</div>
      </div>
    </div>
    <button type="button" mat-icon-button class="text-secondary" (click)="onClose()">
      <mat-icon [icIcon]="icClose"></mat-icon>
    </button>
  </div>
  <mat-divider class="-mx-6 text-border"></mat-divider>
  <elastic-kumobot [isGlobal]="isGlobal"></elastic-kumobot>
</div>
